var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"height":162,"options":_vm.visitorBarChartConfig,"series":[{ data: _vm.CrmRevenueGrowthSeries }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }